import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pcbread-crumb',
  templateUrl: './pcbread-crumb.component.html',
  styleUrls: ['./pcbread-crumb.component.css']
})
export class PCBreadCrumbComponent {

  @Input() data?: string;
  public parentBreadCrumb:string[]=[];
  public thisPage:string='';

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['data'] && changes['data'].currentValue !== undefined) {
      const newData = changes['data'].currentValue;

      if (newData) {
        var splitBreadCrumb=newData.split(',');

        for (let index = 0; index < splitBreadCrumb.length; index++) {
          const element = splitBreadCrumb[index];
          
          if (index+1==splitBreadCrumb.length) {
            this.thisPage=element;
          }else{
            this.parentBreadCrumb.push(element);
          }
        }
      }
      
    }
  }
  
}
